<template>
  <vue-countdown-timer
      @end_callback="logoutUser"
      :start-time="start"
      :end-time="end"
      :interval="1000"
      label-position="end"
      :end-text="'Event ended!'"
      :day-txt="'days'"
      :hour-txt="'hours'"
      :minutes-txt="'minutes'"
      :seconds-txt="'seconds'">
    <template slot="start-label">
      <span></span>
    </template>
    <template slot="countdown" slot-scope="scope">
      <span>
        <b-tooltip target="tooltip-button-time-end"
                   placement="bottom">Tempo para sessão expirar. Clique para renovar</b-tooltip>
        <b-button @click="renova()" id="tooltip-button-time-end" style="min-width: 62px"
                  class="mt-3 ml-2"
                  variant="light">{{ scope.props.minutes }}:{{
            scope.props.seconds
          }}</b-button>
        </span>
    </template>
    <template slot="end-text">
      <span>
         <button type="button" style="min-width: 62px" class="btn btn-danger mt-3 ml-2"
                 data-toggle="tooltip"
                 data-placement="bottom"
                 title="Tempo para sessão expirar">00:00
        </button>
      </span>
    </template>
  </vue-countdown-timer>
</template>

<script>
import {authMethods} from "@/state/helpers";
import moment from "moment";
import Swal from "sweetalert2";
import router from "@/router";

export default {
  props: {
    show: Boolean,
  },
  data() {
    return {
      start: moment(),
      end: null,
      minuteCount: undefined
    };
  },
  created() {
    this.parametros();
  },
  watch: {
    minuteCount: {
      handler(value) {
        if (value < 5 && value >= 1) {
          this.modalRenovar(value)
        }
        if (value > 0) {
          setTimeout(() => {
            this.minuteCount--;
          }, 60000);
        }
      },
      immediate: true
    }
  },
  methods: {
    ...authMethods,
    parametros() {
      this.end = this.$store.state.auth.tokenTimeEnd;
      if (!this.end) {
        this.end = 0
      } else {
        this.end = parseInt(this.end)
        const ent_moment = moment.unix(this.end);
        const ent_diff = moment.duration(ent_moment.diff(this.start));
        this.minuteCount = parseInt(ent_diff.asMinutes())
      }
    },
    modalRenovar(minut) {
      const rout = router.currentRoute;
      if (rout.name === 'index') {
        return
      }
      Swal.fire({
        title: "Seu acesso expira em " + minut + " minutos.",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        confirmButtonText: "Renovar acesso",
        cancelButtonColor: "#74788d",
        cancelButtonText: "Agora não"
      }).then(result => {
        if (result.isConfirmed) {
          this.renova();
        }
      });
    },
    renova() {
      this.renovaToken().then((resposta) => {
        if (resposta) {
          this.parametros();
        } else {
          this.logoutUser();
        }
      }).catch((erro) => {
        console.log(erro)
        this.logoutUser();
      })
    },
    logoutUser() {
      this.logOut()
          .catch((erro) => {
            console.log(erro)
          }).finally(() => {
      })
    },
  },
};
</script>
